module.exports = __webpack_public_path__ + "static/img/silhouette-1.svg-inverse.066288d.svg";